import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import style from '../style/Home.module.scss'
import className from "classnames/bind";
import {useSelector} from "react-redux";
import {currentUserSelector} from "~/reduxs/Auth/authSlice";
import {dashboardApi} from "~/api";
import {handleRequest, apiError, formatCurrency} from "~/utils";
import {Loading, Image} from "~/components";
import FontAwesome from "../../../components/FontAwesome";
import {Card, Col, Row} from "antd";
import _ from "lodash";
import {useCan} from "../../../hooks";

const cn = className.bind(style);

function Home()
{
    const currentUser = useSelector(currentUserSelector);

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [statistics, setStatistics] = useState(null);

    const [products, setProducts] = useState(null);

    useEffect(() =>
    {
        loadStatistics();
        loadProducts();
    }, []);

    const loadStatistics = async () =>
    {
        setLoading(true);

        const [error, response] = await handleRequest(dashboardApi.statistics());

        setLoading(false);

        if (!apiError('Lỗi khi tải thống kê', error, response)) {
            setStatistics(response.data);
        }
    };

    const loadProducts = async () =>
    {
        //setLoading(true);

        const [error, response] = await handleRequest(dashboardApi.products());

        //setLoading(false);

        if (!apiError('Lỗi khi tải thống kê', error, response))
        {
            setProducts(response.data);
        }
    };

    const quickActions = [
        {
            title: 'Quản lý sản phẩm',
            icon: "fa-duotone fa-solid fa-box-archive",
            color: 'var(--primary)',
            path: '/product'
        },
        {
            title: 'Nhập hàng',
            icon: "fa-duotone fa-solid fa-file-import",
            color: 'var(--primary)',
            path: '/purchase-order'
        },
        {
            title: 'Đơn hàng',
            icon: "fa-sharp-duotone fa-light fa-cart-flatbed",
            color: 'var(--primary)',
            path: '/order'
        },
        useCan('user_list') && {
            title: 'Nhân Viên',
            icon: "fa-duotone fa-solid fa-users",
            color: 'var(--primary)',
            path: '/user'
        },
        {
            title: 'Báo cáo doanh thu',
            icon: "fa-duotone fa-light fa-chart-line-up",
            color: 'var(--primary)',
            path: '/report/revenue'
        },
        useCan('user_list') && {
            title: 'Doanh thu theo người bán',
            icon: "fa-duotone fa-user-chart ant-menu-item-icon",
            color: 'var(--primary)',
            path: '/report/revenue-by-user'
        },
    ];

    const statsCards = [
        {
            title: 'Số đơn hàng',
            value: statistics?.orders || 0,
            subtitle: 'hôm nay',
            icon: 'fas fa-file-invoice',
            color: 'iconGray'
        },
        {
            title: 'Doanh thu',
            value: formatCurrency(statistics?.subtotal || 0),
            subtitle: 'hôm nay',
            icon: 'fas fa-money-bill-wave',
            color: 'iconBlue'
        },
        {
            title: 'Doanh thu thuần',
            value: formatCurrency(statistics?.total || 0),
            subtitle: 'hôm nay',
            icon: 'fas fa-sack-dollar',
            color: 'iconOrange'
        }
    ];

    if (loading)
    {
        return <Loading />;
    }

    return (
        <div className="container">
            <div className={cn('dashboard')}>
                <div className={cn('dashboardHeader')}>
                    <h1 className={cn('dashboardTitle', 'mb-3')}>Xin chào, <b>{currentUser?.firstname + ' ' + currentUser?.lastname}</b></h1>
                </div>

                <Row gutter={16}>
                    <Col xs={24} lg={9}>
                        <div className={cn('quickActionsGrid')}>
                            {quickActions.map((action, index) => (
                                action !== false && (
                                <div
                                    key={index}
                                    className={cn('quickActionCard')}
                                    onClick={() => navigate(action.path)}
                                    style={{'--action-color': action.color}}
                                >
                                    <div className={cn('quickActionIcon')} style={{backgroundColor: action.color}}>
                                        <span><FontAwesome icon={action.icon} /></span>
                                    </div>
                                    <div className={cn('quickActionTitle')}>{action.title}</div>
                                </div>
                            )))}
                        </div>
                    </Col>
                    <Col xs={24} lg={6}>
                        <div className={cn('statsGrid')}>
                            {statsCards.map((card, index) => (
                                <div key={index} className={cn('statCard')}>
                                    <div className={cn('statHeader')}>
                                        <span className={cn('statTitle')}>{card.title}</span>
                                        <span className={cn('statIcon', card.color)}>
                                    <FontAwesome icon={card.icon} />
                                </span>
                                    </div>
                                    <div className={cn('statValue')}>{card.value}</div>
                                    <div className={cn('statSubtitle')}>
                                        {card.subtitle}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col xs={24} lg={9}>
                        <div className={cn('ranksWrapper')} key={'ranksWrapper'}>
                            <Card title="Top Sản Phẩm Bán Chạy" className={cn('top-customers-card')}>
                                {!_.isEmpty(products) && products.map((card, index) => (
                                    <div className={cn('top-customer-item')} key={card.id || index}>
                                        <div className={cn('customer-rank')}>{index+1}</div>
                                        <div className={cn('customer-info')}>
                                            <div className={cn('customer-name')}>{card.title}</div>
                                            <div className={cn('customer-code')}>{card.code}</div>
                                        </div>
                                        <div className={cn('customer-value')}>{formatCurrency(card.total_revenue)}</div>
                                    </div>
                                ))}
                            </Card>
                        </div>
                    </Col>
                    <Col xs={24} lg={9}>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default Home;